import styled from "styled-components/macro";

export const TargetList = styled.ul`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 24px;
  
  @media (max-width: 1439px) {
    gap: 12px;
  }
  
  @media (max-width: 979px) {
    flex-direction: column;
  }
`

export const TargetItem = styled.li`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 425px;
  
  @media (max-width: 979px) {
    min-width: 100vw;
    margin-top: 8px;
    margin-bottom: 16px;
    padding: 0 8px;
  }
`

type TIcon = {
  icon: string;
}

export const Icon = styled.span<TIcon>`
  width: 45px;
  height: 45px;
  background-image: ${({ icon }) => `url(${icon})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  margin-bottom: 8px;
`

export const Text = styled.p`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  line-height: 86%;
  margin-bottom: 14px;
  text-align: center;

  @media (max-width: 979px) {
    font-size: 30px;
  }
`

export const SmallText = styled.p`
  font-size: 18px;
  line-height: 140%;
  text-align: center;

  @media (max-width: 979px) {
    font-size: 15px;
  }
`
